import React, { Component } from 'react';
import { Get, cekLogin,cekLoginWisata, JENIS_DESA, JENIS_APLIKASI } from '../function/Koneksi';

import { Form } from 'reactstrap';
// import { BrowserRouter as Router, Link } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import { DataToken } from '../function/Format';
import Select from "react-select";

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			style: {},
			alert: null,
			show: false,
			basicTitle: '',
			basicType: 'default',
			pesanAlert: '',
			loading: true,
			jenis_user:{value: 'Operator Administrasi', label: 'Operator Administrasi'},
			frmJenisUser:[
				{value: 'Operator Administrasi', label:'Operator Administrasi'},
				{value: 'Operator Wisata', label:'Operator Wisata'}
			],
			logoWilayah: '',
		};
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	// ================== Sweet Alert ==================
	closeAlert = () => {
		this.setState({
			show: false
		});
	};

	onRecieveInput = (value) => {
		this.setState({
			alert: (
				<SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
					You wrote: {value}
				</SweetAlert>
			)
		});
	};

	hideAlert = () => {
		this.setState({
			alert: null
		});
	};

	// =================================================
	handleSubmit = (event) => {
		event.preventDefault();
		let username = document.getElementById('username').value
		let password = document.getElementById('password').value
		
		let cekLog = {
			username,
			password
		};
		// //console.log(cekLog);
		let resstat = 200;
		
		if(!this.state.jenis_user){
			this.setState({
				show: true,
				basicType: 'warning',
				basicTitle: 'Login gagal',
				pesanAlert: 'Jenis User Wajib diisi'
			});
		}
		else{
			if (username !== '' && password !== '') {
				if (navigator.onLine) {
					if(this.state.jenis_user.value === 'Operator Administrasi'){
						cekLogin('auth/login', cekLog, (res) => {
							console.log('respn login')
							console.log(res)
							// For testing
							if (this.props.handleSubmit) {
								//console.log('ada props ' + res.status);
								this.props.handleSubmit(res.status)
							}
		
							if (res.status === resstat) {
								let cekStatus = DataToken(res.data.token)
								// console.log(cekStatus);
								if (cekStatus.sub.status == 1 || cekStatus.sub.status == 3) {
									sessionStorage.setItem('access_token', res.data.token);
									// For testing
									if (this.props.handleSubmit) {
									} else {
										this.props.history.push('/'); 
									}
								} else {
									this.setState({
										show: true,
										basicType: 'warning',
										basicTitle: 'Login gagal',
										pesanAlert: 'Akun anda tidak aktif, Silahkan hubungi Admin ' + JENIS_DESA
									});
								}
							} else if (res.status === 401) {
								this.setState({
									show: true,
									basicType: 'warning',
									basicTitle: 'Login gagal',
									pesanAlert: 'Akun anda tidak aktif, Silahkan hubungi Admin ' + JENIS_DESA
								});
							} else {
								this.setState({
									show: true,
									basicType: 'danger',
									basicTitle: 'Login',
									pesanAlert: res.data.error + ', Silahkan hubungi tim ' + JENIS_APLIKASI
								});
							}
						});
					}
					else {
						cekLoginWisata('auth/login', cekLog, (res) => {
		
							// For testing
							if (this.props.handleSubmit) {
								//console.log('ada props ' + res.status);
								this.props.handleSubmit(res.status)
							}
		
							if (res.status === resstat) {
								let cekStatus = DataToken(res.data.results.access_token)
								// console.log('cekStatus');
								// console.log(cekStatus);
								if (cekStatus.sub.uuid) {
									sessionStorage.setItem('access_token', res.data.results.access_token);
									sessionStorage.setItem('nama_admin_wisata', res.data.results.data_pengguna.nama);
									// For testing
									if (this.props.handleSubmit) {
									} else {
										this.props.history.push('/'); 
									}
								} else {
									this.setState({
										show: true,
										basicType: 'warning',
										basicTitle: 'Login gagal',
										pesanAlert: 'Akun anda tidak aktif, Silahkan hubungi Admin ' + JENIS_DESA
									});
								}
							} else if (res.status === 422) {
								this.setState({
									show: true,
									basicType: 'warning',
									basicTitle: 'Login gagal',
									pesanAlert: 'Akun anda tidak aktif, Silahkan hubungi Admin ' + JENIS_DESA
								});
							} else {
								this.setState({
									show: true,
									basicType: 'danger',
									basicTitle: 'Login',
									pesanAlert: 'Username atau password salah!'
								});
							}
						});
					}
				} else {
					this.setState({
						show: true,
						basicType: 'info',
						basicTitle: 'Login',
						pesanAlert: 'Jaringan internet tidak aktif...'
					});
					if (this.props.handleSubmit) {
						this.props.handleSubmit('Internet tidak aktif')
					}
				}
			} else {
				if (this.props.handleSubmit) {
					this.props.handleSubmit('Username atau password kosong')
				}
			}
		}
		
	};
	componentDidMount() {
		let cek = localStorage.getItem('SET_API_URL')
		// console.log("APA ISI DIDMOUNT LOGIN")
		// console.log(cek)

		Get("pengaturan-aplikasi", null, data => {
			// console.log(data);
			if (data.results) {
				this.setState({ logoWilayah: data.results.alamat_foto_kop })
			}
		})

		if(cek==null){
			// setTimeout(
			// 	function() {
			// 		window.location.reload();
			// 	},
			// 	2500
			// );
		}
		else{
			this.setState({ 
				loading: false,
				style: { display: 'none' } 
			})
		}
		this.setState({ 
			loading: false,
			style: { display: 'none' } 
		})
		// setTimeout(
		// 	function() {
		// 		this.setState({ style: { display: 'none' } });
		// 	}.bind(this),
		// 	1000
		// );
	}

	
	// ubah select value
	changeSelectValue = (e, sel) => {
		if (e) {
			switch (sel) {
				case "jenis_user":
					this.setState({
						jenis_user: e,
					});
				break;
				default:
				// no default
				break;
			}
		} else {
			switch (sel) {
				case "jenis_user":
					this.setState({ 
						jenis_user: null 
					});
				break;
				default:
				// no default
				break;
			}
		}
		this.forceUpdate();
	};


	random_halaman(items) {
		return items[Math.floor(Math.random()*items.length)];	
	}

	render() {
		let style = this.state.style;
		// const background = require('../assets/images/auth-layer.png');

		let logoAplikasi = <img id='logo-login' src={require('../assets/images/logo-ld.webp').default} alt="logo-aplikasi" style={{ maxWidth: '300px', width: '100%', height: '100%', paddingBottom: '10px' }} />;

		let jenisAplikasi = localStorage.getItem("JENIS_APLIKASI")

		if (jenisAplikasi) {
			switch (jenisAplikasi.toLowerCase()) {
				case "halaman kampung":
					logoAplikasi = (
						<img
							id='logo-login'
							src={require("../assets/images/hk_icon.png")}
							alt="logo-aplikasi"
							style={{ maxHeight: "100px", height: '57px' }}
						/>
					);
					break;
				case "amanat nagari":
					logoAplikasi = (
						<img
							id='logo-login'
							src={require("../assets/images/amanat_nagari_logo.png")}
							alt="logo-aplikasi"
							style={{ maxHeight: "100px", height: '57px' }}
						/>
					);
					break;
				default:
					logoAplikasi = (
						<img
							id='logo-login'
							src={require("../assets/images/logo-ld.webp").default}
							alt="logo-aplikasi"
							style={{ maxWidth: '300px', width: '100%', height: '100%', paddingBottom: '10px' }}
						/>
					);
					break;
			}
		}

		const login99 = <>
			<div style={{ height: '100vh' }}>
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>
				{/* Loader starts */}
				<div className="loader-wrapper" style={style}>
					<div className="loader bg-white">
						<div className="line" />
						<div className="line" />
						<div className="line" />
						<div className="line" />
					</div>
				</div>
				{/* Loader ends */}

				{/*page-wrapper Start*/}
				<div className="page-wrapper h-100">
					<div className="container-fluid h-100">
						{/*login page start*/}
						{/* <div className="authentication-main"> */}
						<div className="authentication-main container h-100" style={{ background: 'none', maxWidth: '1920px', padding: '25px 35px' }}>
							{this.state.loading ? (
							<div className="loader-wrapper h-100" style={style}>
								<div className="loader bg-white">
									<div className="line" />
									<div className="line" />
									<div className="line" />
									<div className="line" />
								</div>
							</div>
							) : (
							<>
							<div id='bg-login-terpadu-main' className='h-100' style={{ width: 'auto', 'height': 'auto', borderRadius: '25px', position: 'relative'}}>
								<div id="logo-absolute-login" style={{ position: 'absolute' }}>
									<img src={require('../assets/images/logo-ld.webp').default} alt="logo-aplikasi" style={{ maxWidth: '200px', width: '100%', height: '100%'}} />
								</div>
							<div className="row h-100">
								<div className="col-xl-6 p-0">
									
								</div>
								<div id='parent-card-login-right' className="col-xl-6 p-0 pr-2 d-flex flex-column justify-content-center align-items-center ">

									<div id='card-login-right' class="card mb-0 px-2" style={{ borderRadius: '35px' }}>
										<div class="card-body">
											<div className="row justify-content-center my-4">
												<div className="col-sm-8 col-12">
													<div className="row mb-0">
														<div className="col-sm-3 d-flex justify-content-center align-items-center pr-0">
															<img id='logo-gambar-login-new' src={this.state.logoWilayah} alt="logo kabupaten / kota" style={{ maxWidth: '110px' }} />
														</div>
														<div id='info-wilayah-login' className="col-sm-9">
															<h5 className='mb-1' style={{ fontSize: '0.9rem' }}>{localStorage.getItem('Nama_DESA')}</h5>
															<h5 className='mb-1' style={{ fontSize: '0.9rem' }}>{localStorage.getItem('NAMA_KABUPATEN')}</h5>
															<h5 className='mb-1' style={{ fontSize: '0.9rem' }}>Provinsi {localStorage.getItem('PROVINSI')}</h5>
														</div>
													</div>
												</div>
											</div>
											<h5 className='text-center text-above-form-login mb-2'>Inovasi Tanpa Batas</h5>
											<h5 id='satu-genggaman-99' className="text-center text-above-form-login mb-4">Solusi Tanpa Henti</h5>

											<Form id="form-login-99" className="theme-form px-3" data-testid="form-login" onSubmit={this.handleSubmit}>
												<div className="form-group inputss">
													<div class="input-group mb-2">
														<div class="input-group-prepend">
															<div class="btn-login-masuk-new input-group-text" style={{ borderRadius: '10px 0 0 10px', border: '1px solid #98a6ad', borderRight: 'none', padding: '0.375rem 0.95rem' }}>
																<i className="fa fa-user icon icon99" style={{ position: 'inherit', color: 'white' }} />
															</div>
														</div>
														<input id="username" name="username" type="text" class="form-control" placeholder="Username" style={{ borderRadius: '0 10px 10px 0', border: '1px solid #98a6ad', borderLeft: 'none', padding: '0.7rem 0.95rem' }} />
													</div>
												</div>
												<div className="form-group inputss">
													<div class="input-group mb-2">
														<div class="input-group-prepend">
															<div class="btn-login-masuk-new input-group-text" style={{ borderRadius: '10px 0 0 10px', border: '1px solid #98a6ad', borderRight: 'none', padding: '0.375rem 0.95rem' }}>
																<i className="fa fa-lock icon icon99" style={{ position: 'inherit', color: 'white' }} />
															</div>
														</div>
														<input id="password" name="password" type="password" class="form-control" placeholder="Password" style={{ borderRadius: '0 10px 10px 0', border: '1px solid #98a6ad', borderLeft: 'none', padding: '0.7rem 0.95rem' }} />
													</div>
												</div>
												<div className="form-group inputss">
													<div class="input-group mb-2 select-input-login1">
														<div class="input-group-prepend">
															<div class="btn-login-masuk-new input-group-text" style={{ borderRadius: '10px 0 0 10px', border: '1px solid #98a6ad', borderRight: 'none', padding: '0.375rem 0.95rem' }}>
																<i className="fa fa-user icon icon99" style={{ position: 'inherit', color: 'white' }} />
															</div>
														</div>
														<Select
															classNamePrefix="select"
															onChange={e => {
															this.changeSelectValue(e, "jenis_user");
															}}
															value={this.state.jenis_user}
															name="jenis_user"
															options={this.state.frmJenisUser}
															placeholder="Pilih Jenis User"
															isClearable
														/>
													</div>
												</div>
												<div className="text-right">
												</div>
												<div className="form-group mt-3 mb-1">
													<button
														id='tombol-masuk-99'
														data-testid="tombol-login"
														type="submit"
														className="btn btn-primary-custom btn-lg btn-block btn-login-masuk-new"
														style={{ borderRadius: '7px', fontWeight: '700', fontSize: '1rem' }}
													>
														MASUK
													</button>
												</div>
												<div className="text-center mt-12" style={{marginTop:'20px',marginBottom:'20px'}}>
													Didukung oleh <br/>
												</div>
												<div className="text-center mt-12">
													{/* <img
														id='logo-kominfo'
														src={require("../assets/images/logo/kominfo.png")}
														alt="logo-kominfo"
														style={{ maxHeight: "100px", height: '57px' }}
													/>
													{"     "}
													&nbsp;&nbsp;&nbsp;&nbsp; */}
													<img
														id='logo-bsre'
														src={require("../assets/images/logo/bsre.png")}
														alt="logo-bsre"
														style={{ maxHeight: "100px", height: '57px' }}
													/>
												</div>
											</Form>
										</div>
									</div>
								</div>
							</div>

							</div>
							</>
							)}
						</div>
						{/*login page end*/}
					</div>
				</div>
				{/*page-wrapper Ends*/}
			</div>
		</>

		const login28 = <>
			<div>
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>
				
				<div className="loader-wrapper" style={style}>
					<div className="loader bg-white">
						<div className="line" />
						<div className="line" />
						<div className="line" />
						<div className="line" />
					</div>
				</div>
				
				<div className="page-wrapper">
					<div className="container-fluid">
						<div className="authentication-main " style={{ background: 'none' }}>
							{this.state.loading ? (
							<div className="loader-wrapper" style={style}>
								<div className="loader bg-white">
									<div className="line" />
									<div className="line" />
									<div className="line" />
									<div className="line" />
								</div>
							</div>
							) : (
							<div className="row">
								<div className="col-md-6 p-0">
									<div
										className="auth-innerright"
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'center',
											backgroundColor: '#ffffff'
										}}
									>
										<div className="authentication-box">
											<div className="text-center">
												<h3
													style={{
														fontWeight: 'bold',
														color: '#ffffff'
													}}
												>
													{logoAplikasi}
												</h3>
											</div>
											{/* <h5 className='text-center text-above-form-login mb-2' style={{ color: "#000" }}>Inovasi Tanpa Batas</h5>
											<h5 id='satu-genggaman-28' className="text-center text-above-form-login mb-4" style={{ color: "#000" }}>Solusi Tanpa Henti</h5> */}

											<div
												className="pl-4 pr-4 mb-0 mt-4"
											>
												<Form className="theme-form" data-testid="form-login" onSubmit={this.handleSubmit}>
													<div className="form-group inputss">
														<div class="input-group mb-2">
															<div class="input-group-prepend">
																<div class="btn-login-masuk-new input-group-text" style={{ borderRadius: '10px 0 0 10px', border: '1px solid #98a6ad', borderRight: 'none' }}>
																	<i className="fa fa-user icon icon28" style={{ position: 'inherit', color: 'white' }} />
																</div>
															</div>
															<input id="username" name="username" type="text" class="form-control" placeholder="Username" style={{ borderRadius: '0 10px 10px 0', border: '1px solid #98a6ad', borderLeft: 'none', padding: '0.7rem 0.95rem' }} />
														</div>
													</div>
													<div className="form-group inputss">
														<div class="input-group mb-2" style={{ borderColor: '#98a6ad' }}>
															<div class="input-group-prepend">
																<div class="btn-login-masuk-new input-group-text" style={{ borderRadius: '10px 0 0 10px', border: '1px solid #98a6ad', borderRight: 'none' }}>
																	<i className="fa fa-lock icon icon28" style={{ position: 'inherit', color: 'white' }} />
																</div>
															</div>
															<input id="password" name="password" type="password" class="form-control" placeholder="Password" style={{ borderRadius: '0 10px 10px 0', border: '1px solid #98a6ad', borderLeft: 'none', padding: '0.7rem 0.95rem' }} />
														</div>
													</div>
													<div className="form-group inputss">
														<div class="input-group mb-2 select-input-login1" style={{ borderColor: '#98a6ad' }}>
															<div class="input-group-prepend">
																<div class="btn-login-masuk-new input-group-text" style={{ borderRadius: '10px 0 0 10px', border: '1px solid #98a6ad', borderRight: 'none' }}>
																	<i className="fa fa-user icon icon28" style={{ position: 'inherit', color: 'white' }} />
																</div>
															</div>
															<Select
																classNamePrefix="select"
																onChange={e => {
																this.changeSelectValue(e, "jenis_user");
																}}
																value={this.state.jenis_user}
																name="jenis_user"
																options={this.state.frmJenisUser}
																placeholder="Pilih Jenis User"
																isClearable
															/>
														</div>
													</div>
													<div className="text-right">
													</div>
													<div className="form-group mt-4">
														<button
															id='tombol-masuk-28'
															data-testid="tombol-login"
															type="submit"
															className="btn btn-primary-custom btn-lg btn-block btn-login-masuk-new"
															style={{ borderRadius: '7px', fontWeight: '700', fontSize: '1rem' }}
														>
															MASUK
														</button>
													</div>
													<div className="text-center mt-12" style={{marginTop:'20px',marginBottom:'20px'}}>
														Didukung oleh <br/>
													</div>
													<div className="text-center mt-12">
														{/* <img
															id='logo-kominfo'
															src={require("../assets/images/logo/kominfo.png")}
															alt="logo-kominfo"
															style={{ maxHeight: "100px", height: '57px' }}
														/>
														{"     "}
														&nbsp;&nbsp;&nbsp;&nbsp; */}
														<img
															id='logo-bsre'
															src={require("../assets/images/logo/bsre.png")}
															alt="logo-bsre"
															style={{ maxHeight: "100px", height: '57px' }}
														/>
													</div>
												</Form>
											</div>
										</div>
									</div>
								</div>
								<div className="col-md-6 p-0">
									<div
										id="bg-login-terpadu-28"
										className="auth-innerright"
										style={{
											display: 'flex',
											flexDirection: 'row',
											padding: 0,
											position: 'relative',
											justifyContent: 'center'
										}}
									>
										<div className="text-center">
											{/* {logoAplikasi} */}
											<h3
											style={{
												fontWeight: "bold",
												color: "#ffffff",
												textShadow: "1px 0px 5px #000000"
											}}
											>
											<div>Inovasi Tanpa Batas</div>
											<div>Solusi Tanpa Henti</div>
											</h3>
										</div>
										{/* <div className="row mb-0" style={{ position: "absolute", top: '26px', right: '17px' }}>
											<div id='info-wilayah-login' className="text-right col-sm-8">
												<h5 className='mb-1' style={{ fontSize: '0.9rem' }}>{localStorage.getItem('Nama_DESA')}</h5>
												<h5 className='mb-1' style={{ fontSize: '0.9rem' }}>{localStorage.getItem('NAMA_KABUPATEN')}</h5>
												<h5 className='mb-1' style={{ fontSize: '0.9rem' }}>Provinsi {localStorage.getItem('PROVINSI')}</h5>
											</div>
											<div className="col-sm-3 d-flex justify-content-center align-items-center pr-0">
												<img id='logo-gambar-login-new' src={this.state.logoWilayah} alt="logo kabupaten / kota" style={{ maxWidth: '110px' }} />
											</div>
										</div> */}
									</div>
								</div>
							</div>
							)}
						</div>
						{/*login page end*/}
					</div>
				</div>
				{/*page-wrapper Ends*/}
			</div>
		</>

		const login15 = <>
			<div>
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>
				{/* Loader starts */}
				<div className="loader-wrapper" style={style}>
					<div className="loader bg-white">
						<div className="line" />
						<div className="line" />
						<div className="line" />
						<div className="line" />
						{/* <h4>
              Have a great day at work today <span>&#x263A;</span>
            </h4> */}
					</div>
				</div>
				{/* Loader ends */}

				{/*page-wrapper Start*/}
				<div className="page-wrapper">
					<div className="container-fluid pl-0" style={{ backgroundColor: "#3FC05F", position: "relative" }}>
						<div className="row mb-0" style={{ position: "absolute", top: '25px', left: '30px' }} >
							<div className="col-3 d-flex justify-content-center align-items-center pr-0">
								<img id='logo-gambar-login-new' src={this.state.logoWilayah} alt="logo kabupaten / kota" style={{ maxWidth: '110px' }} />
							</div>
							<div id='info-wilayah-login' className="col-9">
								<h5 className='mb-1' style={{ fontSize: '0.9rem', color: '#fff' }}>{localStorage.getItem('Nama_DESA')}</h5>
								<h5 className='mb-1' style={{ fontSize: '0.9rem', color: '#fff' }}>{localStorage.getItem('NAMA_KABUPATEN')}</h5>
								<h5 className='mb-1' style={{ fontSize: '0.9rem', color: '#fff' }}>Provinsi {localStorage.getItem('PROVINSI')}</h5>
							</div>
						</div>
						<div className="authentication-main d-flex justify-content-center" style={{ background: 'none', height: '100%' }}>
							{this.state.loading ? (
							<div className="loader-wrapper" style={style}>
								<div className="loader bg-white">
									<div className="line" />
									<div className="line" />
									<div className="line" />
									<div className="line" />
								</div>
							</div>
							) : (
							<div className="row">
								<div className="col-12 d-flex justify-content-center align-items-center p-0">
									<div class="card d-flex my-5" style={{ width: '27rem', borderRadius: '29px', overflow: "hidden", position: "relative" }}>
										<img className='align-self-center' src={require('../assets/images/logo-ld.webp').default} alt="logo-aplikasi" style={{ maxHeight: '42px', height: '42px', width: 'fit-content', maxWidth: '100%', position: "absolute", top: "20px"}} />
										<img src={require('../assets/images/bg-login28.webp').default} class="card-img-top" alt="..." style={{ maxHeight: '280px', objectFit: "cover" }} />
										<div class="card-body" style={{ paddingTop: '15px' }}>
											<h5 className="text-center text-above-form-login mb-3" >MASUK</h5>
											<Form className="theme-form" data-testid="form-login" onSubmit={this.handleSubmit}>
												<div className="form-group inputss">
													<label for="exampleInputEmail1">Username</label>
													<input
														required
														type="text"
														data-testid="username"
														id="username"
														name="username"
														className="form-control form-control-lg input-border-bottom-only"
														placeholder="Masukkan username"
														style={{
															borderRadius: '0px',
															border: '1px solid #98a6ad',
															borderTop: 'none',
															borderLeft: 'none',
															borderRight: 'none',
															paddingLeft: '10px'
														}}
													/>
												</div>
												<div className="form-group inputss">
													<label for="exampleInputEmail1">Password</label>
													<input
														required
														type="password"
														id="password"
														data-testid="password"
														className="form-control form-control-lg input-border-bottom-only"
														placeholder="Masukkan password"
														name="password"
														style={{
															borderRadius: '0px',
															border: '1px solid #98a6ad',
															borderTop: 'none',
															borderLeft: 'none',
															borderRight: 'none',
															paddingLeft: '10px'
														}}
													/>
												</div>
												<div className="form-group inputss">
													<Select
														classNamePrefix="select"
														onChange={e => {
														this.changeSelectValue(e, "jenis_user");
														}}
														value={this.state.jenis_user}
														name="jenis_user"
														options={this.state.frmJenisUser}
														placeholder="Pilih Jenis User"
														isClearable
													/>
												</div>
												<div className="form-group text-center mt-4">
													<button
														data-testid="tombol-login"
														type="submit"
														className="btn btn-primary-custom btn-login-masuk-new form-control form-control-lg"
														style={{ borderRadius: '17px', width: '80%' }}
													>
														Masuk
													</button>
												</div>
												<div className="text-center mt-12" style={{marginTop:'20px',marginBottom:'20px'}}>
													Didukung oleh <br/>
												</div>
												<div className="text-center mt-12">
													{/* <img
														id='logo-kominfo'
														src={require("../assets/images/logo/kominfo.png")}
														alt="logo-kominfo"
														style={{ maxHeight: "100px", height: '57px' }}
													/>
													{"     "}
													&nbsp;&nbsp;&nbsp;&nbsp; */}
													<img
														id='logo-bsre'
														src={require("../assets/images/logo/bsre.png")}
														alt="logo-bsre"
														style={{ maxHeight: "100px", height: '57px' }}
													/>
												</div>
											</Form>
										</div>
									</div>
									
								</div>
							</div>
							)}
						</div>
						{/*login page end*/}
					</div>
				</div>
				{/*page-wrapper Ends*/}
			</div>
		</>

		const login46 = <>
			<div>
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>
				<div className="loader-wrapper" style={style}>
					<div className="loader bg-white">
						<div className="line" />
						<div className="line" />
						<div className="line" />
						<div className="line" />
					</div>
				</div>

				<div className="page-wrapper">
					<div id='bg-login-terpadu-57' className="container-fluid p-0" style={{ height: "100vh", backgroundColor: "#3FC05F", position: "relative" }}>
						<div className="authentication-main d-flex justify-content-center" style={{ background: 'none', height: '100%' }}>
							{this.state.loading ? (
							<div className="loader-wrapper" style={style}>
								<div className="loader bg-white">
									<div className="line" />
									<div className="line" />
									<div className="line" />
									<div className="line" />
								</div>
							</div>
							) : (
							<div className="row m-0">
								<div className="col-12 d-flex justify-content-center align-items-center p-0">
									<div class="card card-login46 d-flex my-5 mx-2" style={{ borderRadius: '29px', position: "relative", background: "transparent" }}>
										<div className="card-header" style={{ padding: '0px', background: "transparent", borderBottom: 'none', marginBottom: '0px' }}>
											<div className="row m-0" >
												<div className="col-7" style={{ borderRadius: '29px 17px 0 0', padding: '25px 25px 10px 25px', background: "white" }}>
													<div className="row mb-0">
														<div className="col-3 d-flex justify-content-center align-items-center pr-0">
															<img id='logo-gambar-login-new' src={this.state.logoWilayah} alt="logo kabupaten / kota" style={{ maxWidth: '110px' }} />
														</div>
														<div id='info-wilayah-login' className="col-9">
															<h5 style={{ fontSize: '0.85rem', color: "#000", marginBottom: '0.15rem', textTransform: 'none' }}>{localStorage.getItem('Nama_DESA')}</h5>
															<h5 style={{ fontSize: '0.85rem', color: "#000", marginBottom: '0.15rem', textTransform: 'none' }}>{localStorage.getItem('NAMA_KABUPATEN')}</h5>
															<h5 style={{ fontSize: '0.85rem', color: "#000", marginBottom: '0.15rem', textTransform: 'none' }}>Provinsi {localStorage.getItem('PROVINSI')}</h5>
														</div>
													</div>
												</div>
												<div className="col-1" style={{ borderRadius: '17px 0 0 0', background: 'white', padding: '0px'}}>
													<div style={{ paddingTop: '0px', width: '100%', height: '100%', background: '#444444', borderRadius: '15px 0 0 0' }}>
														<div id='login-shape-left-bottom-circle' style={{ background: 'white', height: '103%', marginLeft: '-7px', marginRight: '-9px', zIndex:'1', position:'relative', borderRadius: '25px 0px 0px 0px' }}></div>
													</div>
												</div>
												<div className="col-4" style={{ background: "white", borderRadius: '0 29px 0 0', padding: '0' }}>
													<div className='d-flex' style={{ width: '100%', height: '100%', background: "#444444", borderRadius: '0 29px 0 14%', paddingRight: '15px', paddingLeft: '15px' }}>
														<img className='align-self-center' src={require('../assets/images/logo-ld.webp').default} alt="logo-aplikasi" style={{ maxHeight: '28px', height: '28px', width: 'fit-content', maxWidth: '100%', }} />
													</div>
												</div>
											</div>
										</div>
										<div class="card-body" style={{ padding: '0px', background: '#444444', borderRadius: '29px 0 29px 29px' }}>
											<div style={{ padding: '15px 30px 30px', background: 'white', borderRadius: '0 29px 29px' }}>
												<h5 className="text-center text-above-form-login my-3" style={{ fontSize: '1.3rem', letterSpacing: '3px' }} >MASUK</h5>
												<Form className="theme-form" data-testid="form-login" onSubmit={this.handleSubmit}>
													<div className="form-group inputss">
														<input
															required
															type="text"
															data-testid="username"
															id="username"
															name="username"
															className="form-control form-control-lg input-border-bottom-only"
															placeholder="Username"
															style={{
																borderRadius: '0px',
																border: '1px solid #98a6ad',
																borderTop: 'none',
																borderLeft: 'none',
																borderRight: 'none',
																paddingLeft: '10px'
															}}
														/>
													</div>
													<div className="form-group inputss">
														<input
															required
															type="password"
															id="password"
															data-testid="password"
															className="form-control form-control-lg input-border-bottom-only"
															placeholder="Kata sandi"
															name="password"
															style={{
																borderRadius: '0px',
																border: '1px solid #98a6ad',
																borderTop: 'none',
																borderLeft: 'none',
																borderRight: 'none',
																paddingLeft: '10px'
															}}
														/>
													</div>
													<div className="form-group inputss">
														<Select
															classNamePrefix="select"
															onChange={e => {
															this.changeSelectValue(e, "jenis_user");
															}}
															value={this.state.jenis_user}
															name="jenis_user"
															options={this.state.frmJenisUser}
															placeholder="Pilih Jenis User"
															isClearable
														/>
													</div>
													<div className="text-center mt-12" style={{marginTop:'20px',marginBottom:'20px'}}>
														Didukung oleh <br/>
													</div>
													<div className="text-center mt-12">
														{/* <img
															id='logo-kominfo'
															src={require("../assets/images/logo/kominfo.png")}
															alt="logo-kominfo"
															style={{ maxHeight: "100px", height: '57px' }}
														/>
														{"     "}
														&nbsp;&nbsp;&nbsp;&nbsp; */}
														<img
															id='logo-bsre'
															src={require("../assets/images/logo/bsre.png")}
															alt="logo-bsre"
															style={{ maxHeight: "100px", height: '57px' }}
														/>
													</div>

													<div className="form-group text-center" style={{ marginBottom: '-50px', marginTop: '3rem' }} >
														<button
															data-testid="tombol-login"
															type="submit"
															className="btn btn-primary-custom btn-login-masuk-new form-control form-control-lg"
															style={{ borderRadius: '27px', width: '60%', fontWeight: '700', paddingBottom: '0.7rem', paddingTop: '0.7rem' }}
														>
															MASUK
														</button>
													</div>
												</Form>
											</div>
										</div>
									</div>
									
								</div>
							</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</>

		const login57 = <>
			<div>
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>
				
				<div className="loader-wrapper" style={style}>
					<div className="loader bg-white">
						<div className="line" />
						<div className="line" />
						<div className="line" />
						<div className="line" />
					</div>
				</div>
				
				<div className="page-wrapper">
					<div id="bg-login-terpadu-57" className="container-fluid" style={{ height: '100vh', position: "relative" }}>
						<img src={require('../assets/images/vector-57.webp').default} alt="vector-57" style={{ width: '100%', position: 'absolute', bottom: '0px', objectFit: "fill" }} />
						<div className="row mb-0" style={{ position: "absolute", bottom: '20px', right: '50px' }}>
							<div id='info-wilayah-login' className=" text-right col-9">
								<h5 className='mb-1' style={{ fontSize: '0.9rem', color: "white" }}>{localStorage.getItem('Nama_DESA')}</h5>
								<h5 className='mb-1' style={{ fontSize: '0.9rem', color: "white" }}>{localStorage.getItem('NAMA_KABUPATEN')}</h5>
								<h5 className='mb-1' style={{ fontSize: '0.9rem', color: "white" }}>Provinsi {localStorage.getItem('PROVINSI')}</h5>
							</div>
							<div className="col-3 d-flex justify-content-center align-items-center pr-0">
								<img id='logo-gambar-login-new' src={this.state.logoWilayah} alt="logo kabupaten / kota" style={{ maxWidth: '110px' }} />
							</div>
						</div>

						<div className="authentication-main div-login57 d-flex justify-content-center" style={{ background: 'none', height: '100%' }}>
							{this.state.loading ? (
							<div className="loader-wrapper" style={style}>
								<div className="loader bg-white">
									<div className="line" />
									<div className="line" />
									<div className="line" />
									<div className="line" />
								</div>
							</div>
							) : (
							<div className="row">
								<div className="col-12 d-flex justify-content-center align-items-center p-0">
									<div class="card card-login57 d-flex my-5" style={{ width: '27rem', borderRadius: '29px', overflow: "hidden", position: "relative", background: "transparent", boxShadow: "none" }}>
										<div class="card-body" style={{ paddingTop: '15px' }}>
											<div className="text-center mt-3">
												<h3
													style={{
														fontWeight: 'bold',
														color: '#ffffff'
													}}
												>
													{logoAplikasi}
												</h3>
											</div>
											<h5 className="text-center text-above-form-login mb-1 mt-4" style={{ color: "#fff" }}>Inovasi Tanpa Batas</h5>
											<h5 id='satu-genggaman-28' className="text-center text-above-form-login mb-4" style={{ color: "#fff" }}>Solusi Tanpa Henti</h5>
											<Form className="theme-form" data-testid="form-login" onSubmit={this.handleSubmit}>
												<div className="form-group inputss">
													<i className="fa fa-user icon icon57 primary-color-login-new" />
													<input
														required
														type="text"
														data-testid="username"
														id="username"
														name="username"
														className="form-control form-control-lg inputs"
														placeholder="Enter your username"
														style={{
															borderRadius: '7px',
															lineHeight: '1.7',
															border: '1px solid #98a6ad'
														}}
													/>
												</div>
												<div className="form-group inputss">
													<i className="fa fa-lock icon icon57 primary-color-login-new" />
													<input
														required
														type="password"
														id="password"
														data-testid="password"
														className="form-control form-control-lg inputs"
														placeholder="Enter your password"
														name="password"
														style={{
															borderRadius: '7px',
															lineHeight: '1.7',
															border: '1px solid #98a6ad'
														}}
													/>
												</div>
												<div className="form-group inputss">
													<i className="fa fa-lock icon icon57 primary-color-login-new" />
													<Select
														classNamePrefix="select"
														onChange={e => {
														this.changeSelectValue(e, "jenis_user");
														}}
														value={this.state.jenis_user}
														name="jenis_user"
														options={this.state.frmJenisUser}
														placeholder="Pilih Jenis User"
														isClearable
													/>
												</div>
												<div className="form-group text-center mt-4">
													<button
														data-testid="tombol-login"
														type="submit"
														className="btn btn-primary-custom btn-login-masuk-new form-control form-control-lg"
														style={{ borderRadius: '9px', fontWeight: '700' }}
													>
														MASUK
													</button>
												</div>
												<div className="text-center mt-12" style={{marginTop:'50px',marginBottom:'20px'}}>
													Didukung oleh <br/>
												</div>
												<div className="text-center mt-12">
													{/* <img
														id='logo-kominfo'
														src={require("../assets/images/logo/kominfo.png")}
														alt="logo-kominfo"
														style={{ maxHeight: "100px", height: '57px' }}
													/>
													{"     "}
													&nbsp;&nbsp;&nbsp;&nbsp; */}
													<img
														id='logo-bsre'
														src={require("../assets/images/logo/bsre.png")}
														alt="logo-bsre"
														style={{ maxHeight: "100px", height: '57px' }}
													/>
												</div>

											</Form>
										</div>
									</div>
									
								</div>
							</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</>

		const login63 = <>
			<div>
				<SweetAlert
					show={this.state.show}
					type={this.state.basicType}
					title={this.state.basicTitle}
					confirmBtnBsStyle="success"
					onConfirm={this.closeAlert}
				>
					{this.state.pesanAlert}
				</SweetAlert>
				<div className="loader-wrapper" style={style}>
					<div className="loader bg-white">
						<div className="line" />
						<div className="line" />
						<div className="line" />
						<div className="line" />
					</div>
				</div>

				<div className="page-wrapper">
					<div className="container-fluid p-0" style={{ height: "100vh", backgroundColor: "#3FC05F", position: "relative" }}>
						<div className="authentication-main d-flex flex-column justify-content-center align-items-center" style={{ background: 'none', height: '100%' }}>
							{this.state.loading ? (
							<div className="loader-wrapper" style={style}>
								<div className="loader bg-white">
									<div className="line" />
									<div className="line" />
									<div className="line" />
									<div className="line" />
								</div>
							</div>
							) : (
							<div className="row m-0" style={{ width: '100%', height: '100%' }}>
								<div id='bg-login-terpadu-63' className="col-md-6" style={{ borderRadius: '0 75px 75px 0' }}>

								</div>
								<div className="col-md-6 d-flex justify-content-center align-items-center">
									<div class="card card-login46 d-flex my-5 mx-2" style={{ borderRadius: '29px', position: "relative", background: "transparent", maxWidth: '30rem' }}>
										<div className="card-header" style={{ padding: '0px', background: "transparent", borderBottom: 'none', marginBottom: '0px' }}>
											<div className="row m-0" >
												<div className="col-7" style={{ borderRadius: '29px 17px 0 0', padding: '25px 25px 10px 25px', background: "white" }}>
													<div className="row mb-0">
														<div className="col-3 d-flex justify-content-center align-items-center pr-0">
															<img id='logo-gambar-login-new' src={this.state.logoWilayah} alt="logo kabupaten / kota" style={{ maxWidth: '110px' }} />
														</div>
														<div id='info-wilayah-login' className="col-9">
															<h5 style={{ fontSize: '0.85rem', color: "#000", marginBottom: '0.15rem', textTransform: 'none' }}>{localStorage.getItem('Nama_DESA')}</h5>
															<h5 style={{ fontSize: '0.85rem', color: "#000", marginBottom: '0.15rem', textTransform: 'none' }}>{localStorage.getItem('NAMA_KABUPATEN')}</h5>
															<h5 style={{ fontSize: '0.85rem', color: "#000", marginBottom: '0.15rem', textTransform: 'none' }}>Provinsi {localStorage.getItem('PROVINSI')}</h5>
														</div>
													</div>
												</div>
												<div className="col-1" style={{ borderRadius: '17px 0 0 0', background: 'white', padding: '0px' }}>
													<div style={{ paddingTop: '0px', width: '100%', height: '100%', background: '#1A6A2E', borderRadius: '17px 0 0 0' }}>
														<div id='login-shape-left-bottom-circle' style={{ background: 'white', height: '108%', position:'relative', zIndex:'1', marginLeft:'-7px', marginRight:'-10px', borderRadius: '25px 0px 0px 0px' }}></div>
													</div>
												</div>
												<div className="col-4" style={{ background: "white", borderRadius: '0 29px 0 0', padding: '0' }}>
													<div className='d-flex justify-content-center align-items-center' style={{ display: 'flex', width: '100%', height: '100%', background: "#1A6A2E", borderRadius: '0 29px 0 14%', paddingRight: '15px', paddingLeft: '15px' }}>
														<img src={require('../assets/images/logo-ld.webp').default} alt="logo-aplikasi" style={{ maxHeight: '28px', height: '28px', width: 'fit-content', maxWidth: '100%', }} />
													</div>
												</div>
											</div>
										</div>
										<div class="card-body" style={{ padding: '0px', background: '#1A6A2E', borderRadius: '29px 0 29px 29px' }}>
											<div style={{ padding: '15px 30px 30px', background: 'white', borderRadius: '0 29px 29px' }}>
												<h5 className="text-center text-above-form-login my-3" style={{ fontSize: '1.3rem', letterSpacing: '3px' }} >MASUK</h5>
												<Form className="theme-form" data-testid="form-login" onSubmit={this.handleSubmit}>
													<div className="form-group inputss">
														<input
															required
															type="text"
															data-testid="username"
															id="username"
															name="username"
															className="form-control form-control-lg input-border-bottom-only"
															placeholder="Username"
															style={{
																borderRadius: '0px',
																border: '1px solid #98a6ad',
																borderTop: 'none',
																borderLeft: 'none',
																borderRight: 'none',
																paddingLeft: '10px'
															}}
														/>
													</div>
													<div className="form-group inputss">
														<input
															required
															type="password"
															id="password"
															data-testid="password"
															className="form-control form-control-lg input-border-bottom-only"
															placeholder="Kata sandi"
															name="password"
															style={{
																borderRadius: '0px',
																border: '1px solid #98a6ad',
																borderTop: 'none',
																borderLeft: 'none',
																borderRight: 'none',
																paddingLeft: '10px'
															}}
														/>
													</div>
													<div className="form-group inputss">
														<Select
															classNamePrefix="select"
															onChange={e => {
															this.changeSelectValue(e, "jenis_user");
															}}
															value={this.state.jenis_user}
															name="jenis_user"
															options={this.state.frmJenisUser}
															placeholder="Pilih Jenis User"
															isClearable
														/>
													</div>
													<div className="text-center mt-12" style={{marginTop:'50px',marginBottom:'20px'}}>
														Didukung oleh <br/>
													</div>
													<div className="text-center mt-12">
														{/* <img
															id='logo-kominfo'
															src={require("../assets/images/logo/kominfo.png")}
															alt="logo-kominfo"
															style={{ maxHeight: "100px", height: '57px' }}
														/>
														{"     "}
														&nbsp;&nbsp;&nbsp;&nbsp; */}
														<img
															id='logo-bsre'
															src={require("../assets/images/logo/bsre.png")}
															alt="logo-bsre"
															style={{ maxHeight: "100px", height: '57px' }}
														/>
													</div>
													<div className="form-group text-center" style={{ marginBottom: '-50px', marginTop: '3rem' }} >
														<button
															data-testid="tombol-login"
															type="submit"
															className="btn btn-primary-custom btn-login-masuk-new-2 form-control form-control-lg"
															style={{ borderRadius: '27px', width: '60%', fontWeight: '700', paddingBottom: '0.7rem', paddingTop: '0.7rem' }}
														>
															MASUK
														</button>
													</div>
												</Form>
											</div>
										</div>
									</div>
									
								</div>
							</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</>

		const listHalaman = [
			// login1,
			login99,
			login28,
			login15,
			login46,
			login57,
			login63,
		]

		// var indexLoginPage = process.env.REACT_APP_LOGIN_PAGE;
		var indexLoginPage = 1;

		if (typeof indexLoginPage === 'undefined') {
			indexLoginPage = 1
		}

		return listHalaman[indexLoginPage];
		return this.random_halaman(listHalaman);
		return login63;
		
		// return (
		// 	<div>
		// 		<SweetAlert
		// 			show={this.state.show}
		// 			type={this.state.basicType}
		// 			title={this.state.basicTitle}
		// 			confirmBtnBsStyle="success"
		// 			onConfirm={this.closeAlert}
		// 		>
		// 			{this.state.pesanAlert}
		// 		</SweetAlert>
		// 		{/* Loader starts */}
		// 		<div className="loader-wrapper" style={style}>
		// 			<div className="loader bg-white">
		// 				<div className="line" />
		// 				<div className="line" />
		// 				<div className="line" />
		// 				<div className="line" />
		// 				{/* <h4>
        //       Have a great day at work today <span>&#x263A;</span>
        //     </h4> */}
		// 			</div>
		// 		</div>
		// 		{/* Loader ends */}

		// 		{/*page-wrapper Start*/}
		// 		<div className="page-wrapper">
		// 			<div className="container-fluid">
		// 				{/*login page start*/}
		// 				{/* <div className="authentication-main"> */}
		// 				<div className="authentication-main " style={{ background: 'none' }}>
		// 					{this.state.loading ? (
		// 					<div className="loader-wrapper" style={style}>
		// 						<div className="loader bg-white">
		// 							<div className="line" />
		// 							<div className="line" />
		// 							<div className="line" />
		// 							<div className="line" />
		// 						</div>
		// 					</div>
		// 					) : (
		// 					<div className="row">
		// 						<div className="col-md-6 p-0">
		// 							<div
		// 								id="bg-login-terpadu-new"
		// 								className="auth-innerright"
		// 								style={{
		// 									// backgroundImage: 'url(' + background + ')',
		// 									// background: 'none',
		// 									display: 'flex',
		// 									flexDirection: 'row',
		// 									justifyContent: 'center'
		// 									//   background: "#ffffff"
		// 								}}
		// 							>
		// 								<div className="text-center">
		// 									<h3
		// 										style={{
		// 											fontWeight: 'bold',
		// 											color: '#ffffff',
		// 											textShadow: '1px 0px 5px #000000'
		// 										}}
		// 									>
		// 										<div>Inovasi Tanpa Batas</div>
		// 										<div>Solusi Tanpa Henti</div>
		// 									</h3>
		// 								</div>
		// 							</div>
		// 						</div>
		// 						<div className="col-md-6 p-0">
		// 							<div
		// 								// id="bg-login-terpadu"
		// 								className="auth-innerright"
		// 								style={{
		// 									// backgroundColor: '#E7FED5',
		// 									display: 'flex',
		// 									flexDirection: 'row',
		// 									justifyContent: 'center',
		// 									backgroundColor: '#ffffff'
		// 									// background: 'none'
		// 								}}
		// 							>
		// 								<div className="authentication-box">
		// 									<div className="text-center">
		// 										<h3
		// 											style={{
		// 												fontWeight: 'bold',
		// 												color: '#ffffff'
		// 											}}
		// 										>
		// 											{logoAplikasi}
		// 											{/* {localStorage.getItem("JENIS_APLIKASI")} */}
		// 										</h3>
		// 									</div>
		// 									{/* <div className="card mt-4 p-4 mb-0"> */}
		// 									<div
		// 										className="pl-4 pr-4 mb-0 mt-4"
		// 										style={{
		// 											//   borderRadius: "40px",
		// 											//   backgroundColor: "#ffffffc7",
		// 											//   boxShadow:
		// 											//     "0 4px 8px 0 #0000003d, 0 6px 20px 0 #0000003d"
		// 											// backgroundImage: 'url(' + background + ')'
		// 										}}
		// 									>
		// 										<Form className="theme-form" data-testid="form-login" onSubmit={this.handleSubmit}>
		// 											<div className="form-group inputss">
		// 												<i className="fa fa-user icon" />
		// 												<input
		// 													required
		// 													type="text"
		// 													data-testid="username"
		// 													id="username"
		// 													name="username"
		// 													className="form-control form-control-lg inputs"
		// 													placeholder="Username"
		// 													style={{
		// 														borderRadius: '7px',
		// 														border: '1px solid #98a6ad'
		// 													}}
		// 												/>
		// 											</div>
		// 											<div className="form-group inputss">
		// 												<i className="fa fa-lock icon" />
		// 												<input
		// 													required
		// 													type="password"
		// 													id="password"
		// 													data-testid="password"
		// 													className="form-control form-control-lg inputs"
		// 													placeholder="Password"
		// 													name="password"
		// 													style={{
		// 														borderRadius: '7px',
		// 														border: '1px solid #98a6ad'
		// 													}}
		// 												/>
		// 											</div>
		// 											<div className="form-group inputss">
		// 												<i className="fa fa-users icon" />
		// 												<Select
		// 													classNamePrefix="select"
		// 													onChange={e => {
		// 													this.changeSelectValue(e, "jenis_user");
		// 													}}
		// 													value={this.state.jenis_user}
		// 													name="jenis_user"
		// 													options={this.state.frmJenisUser}
		// 													placeholder="Pilih Jenis User"
		// 													isClearable
		// 												/>
		// 											</div>
		// 											<div className="text-right">
		// 												{/* <h6><Link to="/forget-password" ><u className="text-success">Reset Kata Sandi</u></Link></h6> */}
		// 											</div>
		// 											<div className="form-group mt-4">
		// 												<button
		// 													data-testid="tombol-login"
		// 													type="submit"
		// 													className="btn btn-primary-custom form-control form-control-lg"
		// 													style={{ borderRadius: '7px' }}
		// 												>
		// 													{' '}
		// 													Masuk
		// 												</button>
		// 											</div>
		// 										</Form>
		// 									</div>
		// 									<div className="text-center mt-12" style={{marginTop:'50px',marginBottom:'20px'}}>
		// 										Didukung oleh <br/>
		// 									</div>
		// 									<div className="text-center mt-12">
		// 										{/* <img
		// 											id='logo-kominfo'
		// 											src={require("../assets/images/logo/kominfo.png")}
		// 											alt="logo-kominfo"
		// 											style={{ maxHeight: "100px", height: '57px' }}
		// 										/>
		// 										{"     "}
		// 										&nbsp;&nbsp;&nbsp;&nbsp; */}
		// 										<img
		// 											id='logo-bsre'
		// 											src={require("../assets/images/logo/bsre.png")}
		// 											alt="logo-bsre"
		// 											style={{ maxHeight: "100px", height: '57px' }}
		// 										/>
		// 										{/* <h6>Belum punya akun? <Link to="#" ><u className="text-success">Daftar disini</u></Link></h6> */}
		// 										{/* <h6>Belum punya akun? <Link to="/register" ><u className="text-success">Daftar disini</u></Link></h6> */}
		// 									</div>
		// 								</div>
		// 							</div>
		// 						</div>
		// 					</div>
		// 					)}
		// 				</div>
		// 				{/*login page end*/}
		// 			</div>
		// 		</div>
		// 		{/*page-wrapper Ends*/}
		// 	</div>
		// );
	}
}

export default Login;
